import React, {useEffect, useState} from "react";
import DefaultPageHeader from "../../../containers/DefaultPageHeader";
import DefaultTableCard from "../../../containers/DefaultTableCard";
import {ApiService} from "../../../services/ApiService";
import {Button, Popconfirm, Space, Spin} from "antd";
import {DeleteOutlined, EditOutlined, QuestionCircleOutlined} from "@ant-design/icons";
import TableLongText from "../../../containers/TableLongText";
import {useNavigate, useSearchParams} from "react-router-dom";

const ReligionVenueListPage = () => {
    const navigation = useNavigate()
    const [searchParams] = useSearchParams()
    const [data, setData] = useState({})
    const [loading, setLoading] = useState(false)
    const [venue, setVenue] = useState({})

    const requestData = (page = 0) => {
        setLoading(true)
        ApiService.admin.camera.list(page, searchParams.get("venueId") ?? 0)
            .onSuccess(data => {
                setData(data)
            })
            .onComplete(() => {
                setLoading(false)
            })
    }

    const requestVenueInfo = () => {
        if (searchParams.get("venueId")) {
            ApiService.admin.religion.venue.get(searchParams.get("venueId"))
                .onSuccess(data => {
                    setVenue(data)
                })
        }
    }

    useEffect(() => {
        requestData()
        requestVenueInfo()
    }, []);

    const handlePageChange = (page, size) => {
        requestData(page - 1)
    }

    const handleHeaderButtonClick = (event, key) => {
        navigation("/camera/edit")
    }

    const handleItemEdit = (event, item) => {
        navigation("/camera/edit?guid=" + item.guid)
    }

    const handleItemDelete = (event, item) => {
        ApiService.admin.camera.remove(item.guid)
            .onSuccess(() => {
                const content = data.content.filter(i => item.guid !== i.guid)
                setData({
                    ...data,
                    content: content
                })
            })
    }

    const tableColumns = [
        {
            title: '#',
            dataIndex: 'id',
            key: 'id',
            fixed: 'left',
            width: 60,
        },
        {
            title: '场所',
            dataIndex: 'properties.venue',
            key: 'properties.venue',
            render: (text, record) => (<TableLongText text={record.properties.venue}/>)
        },
        {
            title: '相机名',
            dataIndex: 'name',
            key: 'name',
            render: (text) => (<TableLongText text={text}/>)
        },
        {
            title: '设备ID',
            dataIndex: 'devicePlatformId',
            key: 'devicePlatformId',
            render: (text) => (<TableLongText text={text}/>)
        },
        {
            title: 'HLS',
            dataIndex: 'hlsUrl',
            key: 'hlsUrl',
            render: (text) => (<TableLongText row={1} text={text}/>)
        },
        {
            title: 'RTMP',
            dataIndex: 'rtmpUrl',
            key: 'rtmpUrl',
            render: (text) => (<TableLongText row={1} text={text}/>)
        },
        {
            title: '操作',
            dataIndex: 'operation',
            key: 'operation',
            width: 88,
            render: (text, record) => (
                <Space size="small">
                    <Button type='primary' size='small' icon={<EditOutlined/>}
                            onClick={event => handleItemEdit(event, record)}/>
                    <Popconfirm title="确定要删除吗" icon={<QuestionCircleOutlined style={{color: 'red'}}/>}
                                onConfirm={event => handleItemDelete(event, record)} okText="确定" cancelText="暂不">
                        <Button type='danger' size='small' icon={<DeleteOutlined/>}/>
                    </Popconfirm>
                </Space>
            )
        },
    ]

    return (
        <Spin spinning={loading}>
            <DefaultPageHeader
                title={(venue?.name ? `【${venue.name}】的` : '') + "摄像机管理"}
                buttons={[{name: "添加相机", key: "new"}]}
                onButtonClick={handleHeaderButtonClick}
            />

            <DefaultTableCard
                currentPage={Number(data?.number ?? "0") + 1}
                columns={tableColumns}
                data={data?.content ?? []}
                total={Number(data?.totalElements ?? 0)}
                pagesize={Number(data?.size ?? 0)}
                loading={false}
                onPageChange={handlePageChange}
            />
        </Spin>
    )
}

export default ReligionVenueListPage